<template>
    <vx-expandable-card id="groups">
        <template v-slot:header> Groups </template>

        <template v-slot:content>
            <div class="vx-flex vx-gap-2 vx-mb-3 lg:vx-mb-6">
                <div class="vx-grow" data-test="group-id-wrapper">
                    <vx-input size="lg"
                        placeholder=""
                        v-model="groupId"
                        @keypress.enter="add()"
                        :error="displayFirstError(validate.groupId)">
                    </vx-input>
                </div>
                <vx-button @click="add()"
                    data-test="group-add"
                    size="lg"
                    type="button">
                    <font-awesome-icon :icon="faCirclePlus"></font-awesome-icon>
                </vx-button>
            </div>
            <vx-icon-loading v-if="loadingGroups"
                spin></vx-icon-loading>
            <vx-alert :closeable="false"
                v-else-if="!groups.length">
                No groups were specified for this contact.
            </vx-alert>
            <div v-else>
                <vx-list-animated v-model="groups"
                    label="group_id"
                    value="group_id"></vx-list-animated>
            </div>
        </template>
    </vx-expandable-card>

</template>

<script setup>
import { faCirclePlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxAlert, VxButton, VxExpandableCard, VxIconLoading, VxInput, VxListAnimated } from '@voxie/frontend-components';
import useVuelidate from '@vuelidate/core';
import { helpers, maxLength, requiredIf } from '@vuelidate/validators';
import { nextTick, ref } from 'vue';
import { displayFirstError } from '~/utils/validation';
import { useContactDetails } from '../useContactDetails';

const teamId = Spark.state.currentTeam.id;

const { contact, groups, loadingGroups } = useContactDetails();

const groupId = ref('');
const adding = ref(false);

const validate = useVuelidate({
    groupId: {
        requiredIf: requiredIf(adding),
        maxLength: maxLength(39),
        format: helpers.withMessage('You can use only alphanumeric letters, and the following symbols: _-', helpers.regex(/^[a-z0-9][a-z0-9_-]*$/)),
    }
}, {
    groupId: groupId,
}, {
    $autoDirty: true,
});

const add = async () => {
    adding.value = true;
    await nextTick();

    const isValid = await validate.value.$validate();
    if (!isValid) {
        setTimeout(() => {
            adding.value = false;
        }, 3500);
        return;
    }

    if (!groups.value.find(group => group.group_id === groupId.value)) {
        groups.value.unshift({
            team_id: teamId,
            contact_id: contact.value.id,
            group_id: groupId.value,
        });
    }

    groupId.value = '';
    adding.value = false;
}

</script>
